export default __webpack_public_path__ + "static/media/washupWelcomeNewsBanner.adfc8609.png";